import React from 'react';
import styled from 'styled-components';
import { CaseCreationProperties } from '../../CreateCaseSchema';
import UserInformationTile from './UserInformationTile';

const UserInformationContentLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
`;

export interface UserInformationContentProps {
  properties: {
    [attribute: string]: CaseCreationProperties;
  };
}

const UserInformationContent: React.FC<UserInformationContentProps> = ({
  properties,
}) => {
  const propertyList: [s: string, t: CaseCreationProperties][] =
    Object.entries<CaseCreationProperties>(properties);
  return (
    <UserInformationContentLayout>
      {propertyList.map((value) => {
        return (
          <UserInformationTile
            key={value[0]}
            attribute={value[0] as string}
            properties={value[1] as CaseCreationProperties}
          />
        );
      })}
    </UserInformationContentLayout>
  );
};

export default UserInformationContent;
